<template lang="html">
<div class="client-list">
  <div class="section-header">
    <div>{{displayHeader}}</div>
    <add-clients @finished="addClient"/>
  </div>
  <div class="card " v-for="client in clients" :key="client.id">
    <div class="card--container row space-between align-center">
      <div class="row align-center" @click="$router.push({name: 'clientDetail', params: {id: client.id}})">
          <avatar :image="client.image" />
          <h3>{{client.first_name}} {{client.last_name}}</h3>
          </div>
      <button @click="revoke(client)">
        <h-icon >delete</h-icon>
      </button>
    </div>
    <v-divider/>
  </div>
  <div class="card card--white" v-if="!clients.length && !loading">
    <div class="card card--container">
      No clients are currently using this
    </div>
  </div>
</div>
</template>

<script>
import addClients from "@/pages/coaches/components/clients/addClientModal";
import avatar from "@/components/userImg";

export default {
  props: ["clients", "loading", "header"],
  components: {
    addClients,
    avatar
  },
  created() {
    this.displayHeader = this.header || "Clients with access";
  },
  data() {
    return {
      displayHeader: ""
    };
  },
  methods: {
    revoke(client) {
      this.$emit("revoke", client);
    },
    addClient(clients) {
      this.$emit("addClients", clients);
    }
  }
};
</script>

<style lang="less">
.client-list {
}
</style>
